<template>
  <generic-container
    icon="cubes"
    :title="$t('nvidia bundles')"
    v-bind:show_plus="true"
    v-on:add="add"
    :show_refresh="true"
    @refresh="refresh_data"
    :configurable="true"
    v-bind:configure_modal="configure_modal"
  >
    <table
      class="ui blue celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("start date") }}</th>
          <th>{{ $t("end date") }}</th>
          <th>{{ $t("cards") }}</th>
          <th>{{ $t("stores") }}</th>
          <th>{{ $t("codes") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <bundle-modal
      v-if="show_bundle_modal"
      @close="show_bundle_modal = false"
      ref="bundle_modal"
      v-on:succedded="succedded"
      @removed="refresh_data"
    />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  local_api,
  error_toast,
  init_json_local_data_datables,
  enterprise_setup,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import BundleModal from "./bundle_modal/Index";
import moment from "moment";

// @ is an alias to /src
export default {
  name: "NvidiaBundleIndex",
  components: {
    "generic-container": GenericContainer,
    BundleModal,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      show_bundle_modal: false,
      graphic_cards: [],
      stores: [],
    };
  },
  methods: {
    succedded() {
      this.refresh_data();
    },
    add() {
      this.show_bundle_modal = true;
    },
    refresh_data() {
      let vm = this;
      let ent_setup = enterprise_setup(vm);
      local_api(this, "post", "/nvidia_bundle/bundle/do-get-list")
        .then((list) => {
          if (list) {
            vm.list = list;
            let columns = [
              {
                data: function (row) {
                  // console.log(row);
                  return row.setup.name;
                },
              },
              {
                data: function (row) {
                  if (row.setup.start_date) {
                    return moment(row.setup.start_date).format(
                      ent_setup.simple_date_format,
                    );
                  } else return "NO DATA";
                },
              },
              {
                data: function (row) {
                  if (row.setup.end_date) {
                    return moment(row.setup.end_date).format(
                      ent_setup.simple_date_format,
                    );
                  } else return "NO DATA";
                },
              },
              {
                data: function (row) {
                  if (row.setup.cards) {
                    let cards = row.setup.cards.split(",");
                    cards = cards.filter((s) => s);
                    let r = cards.reduce((prev, curr) => {
                      let rslt = vm.graphic_cards.find(
                        (s) => String(s.graphic_card_id) == String(curr),
                      );
                      let t = `<div class="ui basic label">
                                <i class="green checkmark icon"></i>
                                ${rslt ? rslt.setup.name : curr}
                              </div>`;
                      return prev + t;
                    }, "");

                    return r;
                  } else return "NO DATA";
                },
              },
              {
                data: function (row) {
                  if (row.setup.stores) {
                    let stores = row.setup.stores.split(",");
                    stores = stores.filter((s) => s);
                    let r = stores.reduce((prev, curr) => {
                      let rslt = vm.stores.find(
                        (s) => String(s.store_id) == String(curr),
                      );
                      let t = `<div class="ui basic label">
                                <i class="green checkmark icon"></i>
                                ${rslt ? rslt.setup.name : curr}
                              </div>`;
                      return prev + t;
                    }, "");

                    return r;
                  } else return "NO DATA";
                },
              },
              {
                data: function (row) {
                  // console.log(row);
                  return `<div class="ui bulleted list"><div class="item">${vm.$t(
                    "total codes",
                  )}: ${row.total_codes}</div><div class="item">${vm.$t(
                    "available codes",
                  )}: ${row.available_codes}</div></div>`;
                },
              },
            ];

            let onSelect = (data) => {
              vm.show_bundle_modal = true;
              setTimeout(() => {
                vm.$refs.bundle_modal.setBundle(data);
              }, 500);
            };

            let onCreatedRow = () => {};
            let onPageChanged = () => {};

            init_json_local_data_datables(
              vm,
              vm.$refs.table,
              vm.list,
              columns,
              onSelect,
              onCreatedRow,
              onPageChanged,
            );
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    getCatalogs() {
      let vm = this;
      local_api(this, "post", "/nvidia_bundle/graphic_card/do-get-list")
        .then((list) => {
          if (list) {
            vm.graphic_cards = list;
          }

          local_api(this, "post", "/nvidia_bundle/store/do-get-list")
            .then((list) => {
              if (list) {
                vm.stores = list;
              }

              vm.refresh_data();
            })
            .catch((err) => {
              error_toast(err);
            });
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  created() {},
  mounted() {
    let vm = this;

    vm.getCatalogs();
  },
  watch: {},
};
</script>
